module.exports = __webpack_public_path__ + "static/img/cam.5415db7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cam.jpg
// module id = BMBb
// module chunks = 1